import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-powered-by-naka',
  templateUrl: './powered-by-naka.component.html',
  styleUrls: ['./powered-by-naka.component.scss']
})
export class PoweredByNakaComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
